module.exports = __webpack_public_path__ + "img/timestudy-bottom.d5bc0780.png";